<template>
<div>
  <el-form size="small" style="margin-right: 30px" :model="addEditForm" :rules="addEditRules" ref="addEditForm" label-width="120px" class="demo-ruleForm">
    <el-form-item label="条件查询老人" prop="" v-if="$store.state.user.moduletag !== 2">
      <el-radio-group v-model="labelval" @change="changeLabel">
        <el-radio-button :label="1">姓名查询</el-radio-button>
        <el-radio-button :label="0">条件查询</el-radio-button>
      </el-radio-group>
    </el-form-item>
    <el-form-item label="老人" prop="pid" v-if="$store.state.user.moduletag === 2">
      <el-select v-fixZoom v-model="addEditForm.pid" filterable placeholder="请选择" :clearable="true" style="width:100%;">
        <el-option v-for="item in elderly" :key="item.index" :label="item.name" :value="item.id">
          <span>{{ getSelectElderlyShow(item) }}</span>
        </el-option>
      </el-select>
    </el-form-item>
    <el-form-item v-else label="老人" prop="pid">
      <div v-if="labelval === 1">
        <el-autocomplete v-if="labelval === 1" size="small" style="width: 300px" class="inline-input" v-model="personName" @blur="blurPerson"
                         :fetch-suggestions="querySearch" placeholder="请输入服务对象姓名" :trigger-on-focus="false" @select="handleSelect">
        </el-autocomplete>
      </div>
      <div v-else>
        <el-row>
          <el-col :span="12">
            <el-cascader v-fixZoom style="width: 100%" :options="orgOptions" v-model="oid" :filterable="true" placeholder="请选择组织"
              :props="{ checkStrictly: true, value: 'id', label: 'name', children: 'child', emitPath: false}" ref="orgOptions" @change="selectOrgID">
            </el-cascader>
          </el-col>
          <el-col :span="12">
            <el-select v-fixZoom v-model="cid" filterable :placeholder="isCenterName" style="width: 100%" @change="selectCommunityID">
              <el-option v-for="item in orgcommunitys" :key="item.value" :label="item.name" :value="item.id">
              </el-option>
            </el-select>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-select v-fixZoom style="width: 100%" v-model="hid" placeholder="请选择已有家庭/机构" @change="selectHomeID">
              <el-option v-for="item in selectorghomes" :key="item.id" :label="item.address" :value="item.id">
                <span style="">{{ item.address }}</span>&nbsp;
                <span style="color: #8492a6; font-size: 12px">{{ item.telephone }}</span>
              </el-option>
            </el-select>
          </el-col>
          <el-col :span="12">
            <el-select v-fixZoom style="width: 100%" filterable v-model="addEditForm.pid" placeholder="请选择所属人员" @change="selectPerson">
              <el-option v-for="item in selectoldpersons" :key="item.index" :label="item.name" :value="item.id"></el-option>
            </el-select>
          </el-col>
        </el-row>
      </div>
    </el-form-item>
    <el-form-item label="健康类型" prop="health_key">
      <div style="max-height: 450px;overflow-y: auto">
        <table border="1" style="border-collapse: collapse;">
          <tr v-for="item in healthdatatype" :key="item.id">
            <td style="padding: 5px"><span>{{item.key_name}}</span></td>
            <td style="padding: 5px"><el-input style="width: 100%" placeholder="请输入数值" v-model="item.value"></el-input></td>
          </tr>
        </table>
      </div>
    </el-form-item>
  </el-form>
  <el-row style="margin: 0 20px">
    <el-col :span="12">
      <div class="cancel-btn" @click="closeOpen()">
        <span>取消</span>
      </div>
    </el-col>
    <el-col :span="12">
      <div class="send-btn" @click="submitAddEdit('addEditForm')">
        <span>确定</span>
      </div>
    </el-col>
  </el-row>
  <div style="height: 20px"></div>
</div>
</template>

<script>
import {queryhealthdatamultiadd} from '../../../api/yanglaoyuan'
import {querycommunitybyorgids} from '../../../api/organizer'
import {queryhomebycids} from '../../../api/relation'
import {queryoldpersonbyhids} from '../../../api/handlealarm'
import {searcholdperson} from '../../../api/serviceObject'

export default {
  name: 'addHealthData',
  model: {
    prop: 'addShow',
    event: 'change'
  },
  props: {
    addHealthObj: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      labelval: 1,
      personName: '',
      elderly: [],
      healthdatatype: [],
      addEditForm: {
        id: 0,
        pid: '',
        epid: '',
        health_data: []
      },
      addEditRules: {
        pid: [
          {required: true, message: '请选择老人', trigger: 'change'}
        ]
      },
      // 居家
      orgOptions: [],
      orgcommunitys: [],
      selectorghomes: [],
      selectoldpersons: [],
      homeAddress: '',
      oid: '',
      cid: '',
      hid: '',
      isLabel: '所属家庭/机构',
      isCenterName: '请选择小区',
      isRightName: '请选择已有家庭'
      // 结束
    }
  },
  created () {
    this.orgOptions = this.addHealthObj.treeData
    this.elderly = this.addHealthObj.elderly
    let arr = this.clone(this.addHealthObj.healthdatatype)
    this.oid = this.addHealthObj.orgid
    for (let i = 0; i < arr.length; i++) {
      let obj = arr[i]
      obj.value = ''
      this.healthdatatype.push(obj)
    }
  },
  methods: {
    getSelectElderlyShow (item) {
      let elderlyName = item.name && item.name !== '' ? item.name : '--'
      let buildName = item.build_name && item.build_name !== '' ? item.build_name : '--'
      let floorName = item.floor_name && item.floor_name !== '' ? item.floor_name : '--'
      let roomName = item.room && item.room !== '' ? item.room + '号间' : '--'
      let bedName = item.bed_name && item.bed_name !== '' ? item.bed_name + '号床' : '--'
      return elderlyName + ' / ' + buildName + '--' + floorName + '--' + roomName + '--' + bedName
    },
    closeOpen () {
      this.$emit('change', false)
    },
    submitAddEdit (formName) {
      // console.log(this.healthdatatype)
      let arr = []
      for (let i = 0; i < this.healthdatatype.length; i++) {
        if (this.healthdatatype[i].value !== '') {
          let obj = {
            id: this.healthdatatype[i].id,
            value: this.healthdatatype[i].value
          }
          arr.push(obj)
        }
      }
      if (arr.length === 0) {
        this.$message({
          message: '至少输入一列数值。',
          type: 'warning'
        })
        return
      }
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let data = {
            id: 0,
            health_data: arr,
            pid: this.addEditForm.pid,
            epid: this.addEditForm.pid
          }
          queryhealthdatamultiadd(data).then(res => {
            this.$notify({title: '成功', message: '成功新增健康数据', type: 'success'})
            this.$emit('updateTable')
            this.$emit('change', false)
          }).catch(() => {})
        }
      })
    },
    // 居家的
    changeLabel (val) {
      this.addEditForm.pid = ''
    },
    // 姓名搜索服务对象
    querySearch (queryString, cb) {
      if (queryString.length < 1) {
        let arr = []
        cb(arr)
        return
      }
      let data = {
        lessname: queryString,
        page: 1,
        size: 9999
      }
      searcholdperson(data).then(res => {
        let re = []
        this.selectoldpersons = res.data.persons
        res.data.persons.forEach(item => {
          re.push({
            value: item.name + '(' + item.h_address + ')',
            row: item,
            id: item.id
          })
        })
        if (re.length === 0) {
          this.$message({ message: '暂无该服务对象。', type: 'warning' })
        }
        cb(re)
      }).catch(() => {
        let arr = []
        cb(arr)
      })
    },
    handleSelect (item) {
      console.log('item', item)
      this.addEditForm.pid = item.id
    },
    blurPerson () {
    },
    // change事件
    selectOrgID (id) {
      this.cid = ''
      let data = {
        orgids: [id]
      }
      querycommunitybyorgids(data).then(res => {
        this.orgcommunitys = res.data.communitys
      }).catch(() => {})
    },
    selectCommunityID (id) {
      this.hid = ''
      this.addEditForm.hid = ''
      this.addEditForm.pid = ''
      this.homeAddress = ''
      for (let i = 0; i < this.orgcommunitys.length; i++) {
        if (id === this.orgcommunitys[i].id) {
          if (this.orgcommunitys[i].zone_type === 1) {
            this.isRightName = '请选择已有家庭'
          } else if (this.orgcommunitys[i].zone_type === 2) {
            this.isRightName = '请选择已有房间'
          }
        }
      }
      let data = {
        cids: [id]
      }
      queryhomebycids(data).then(res => {
        this.selectorghomes = res.data.homes
      }).catch(() => {})
    },
    selectHomeID (id) {
      this.pid = ''
      this.addEditForm.pid = ''
      this.addEditForm.phone = ''
      this.isEdit = false
      let data = {
        hids: [id]
      }
      queryoldpersonbyhids(data).then(res => {
        this.selectoldpersons = res.data.persons
      }).catch(() => {})
    },
    selectPerson (id) {
      console.log(this.addEditForm.pid)
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/oldPersonHome/components/addHealthData.vue